module.exports = __webpack_public_path__ + "img/edit-white.88ab70b5.svg";